import { EpimsBankDetailDto } from '@cradua/data';
import { createAction, props } from '@ngrx/store';

/**
 * Load Countries Collection Actions
 */
export const loadEpimsBankDetail = createAction(
  '[EpimsBankDetail] Load EpimsBankDetail',
  props<{ id: string[] }>()
);

export const loadEpimsBankDetailSuccess = createAction(
  '[EpimsBankDetail] Load EpimsBankDetail Success',
  props<{ bank: EpimsBankDetailDto[] }>()
);

export const loadEpimsBankDetailFailure = createAction(
  '[EpimsBankDetail] Load EpimsBankDetail Failure',
  props<{ error: any }>()
);

/**
 * Add Countries to Collection Actions
 */
export const addEpimsBankDetail = createAction(
  '[EpimsBankDetail] Add EpimsBankDetail',
  props<{ newEpimsBankDetail: EpimsBankDetailDto[] }>()
);

export const addEpimsBankDetailSuccess = createAction(
  '[EpimsBankDetail] Add EpimsBankDetail Success',
  props<{ newEpimsBankDetail: EpimsBankDetailDto[] }>()
);

export const addEpimsBankDetailFailure = createAction(
  '[EpimsBankDetail] Add EpimsBankDetail Failure',
  props<{ error: any }>()
);

/**
 * Update EpimsBankDetail Collection Actions
 */
export const updateEpimsBankDetail = createAction(
  '[EpimsBankDetail] Update EpimsBankDetail',
  props<{ updateEpimsBankDetail: EpimsBankDetailDto[] }>()
);

export const updateEpimsBankDetailSuccess = createAction(
  '[EpimsBankDetail] Update EpimsBankDetail Success',
  props<{ updateEpimsBankDetail: EpimsBankDetailDto[] }>()
);

export const updateEpimsBankDetailFailure = createAction(
  '[EpimsBankDetail] Update EpimsBankDetail Failure',
  props<{ error: any }>()
);

/**
 * Remove EpimsBankDetail Collection Actions
 */
export const removeEpimsBankDetail = createAction(
  '[EpimsBankDetail] Remove EpimsBankDetail',
  props<{ ids: string[] }>()
);

export const removeEpimsBankDetailSuccess = createAction(
  '[EpimsBankDetail] Remove EpimsBankDetail Success',
  props<{ ids: string[] }>()
);

export const removeEpimsBankDetailFailure = createAction(
  '[EpimsBankDetail] Remove EpimsBankDetail Failure',
  props<{ error: any }>()
);
